const {registerModule} = window;

class Tabs {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
    this.selectTabFromHash();
  }

  unmount() {
    this.ui.$tabs.forEach((tab) => {
      tab.removeEventListener('click', this.onClick.bind(this));
      tab.removeEventListener('keydown', this.onKeydown.bind(this));
    });
  }

  bindUI() {
    this.index = 0;
    this.ui = {};
    this.ui.$tabs = this.element.querySelectorAll('[data-ref="tab-link"]');
    this.ui.$panels = this.element.querySelectorAll('[data-ref="tab-panel"]');
  }

  bindEvents() {
    this.ui.$tabs.forEach((tab) => {
      tab.addEventListener('click', this.onClick.bind(this));
      tab.addEventListener('keydown', this.onKeydown.bind(this));
    });
  }

  onClick(e) {
    const target = e.currentTarget;
    const id = target.getAttribute('data-href');

    this.ui.$panels.forEach(($panel) => {
      $panel.classList.remove('selected');
    });

    this.ui.$tabs.forEach(($tab) => {
      $tab.classList.remove('selected');
    });

    this.element.querySelector(`#${id}`).classList.add('selected');
    target.classList.add('selected');

    if (this.element.classList.contains('tabVertical')) {
      this.element.scrollIntoView({block: 'start'});
    }
  }

  onKeydown(e) {
    e.preventDefault();
    const key = e.which || e.keyCode;
    const LEFT_ARROW = 37;
    const UP_ARROW = 38;
    const RIGHT_ARROW = 39;
    const DOWN_ARROW = 40;


    // if the key pressed was an arrow key
    if (key >= LEFT_ARROW && key <= DOWN_ARROW) {
      // move left one tab for left and up arrows
      if (key == LEFT_ARROW || key == UP_ARROW) {
        if (this.index > 0) {
          this.index--;
        } else {
          // unless you are on the first tab,
          // in which case select the last tab.
          this.index = this.ui.$tabs.length - 1;
        }
      } else if (key == RIGHT_ARROW || key == DOWN_ARROW) {
        // move right one tab for right and down arrows
        if (this.index < (this.ui.$tabs.length - 1)) {
          this.index++;
        } else {
        // unless you're at the last tab,
        // in which case select the first one
          this.index = 0;
        }
      }

      // trigger a click event on the tab to move to
      this.ui.$tabs[this.index].click();
      this.setFocus();
      // $(this.ui.$tabs.get(this.index)).click();
    }
  }

  selectTabFromHash() {
    if (window.location.hash && window.document.querySelector(`[href="${window.location.hash}"]`)) {
      const hrefElement = window.document.querySelector(`[href="${window.location.hash}"]`);
      const matchedPanel = hrefElement.closest('[data-ref="tab-panel"]');
      if (matchedPanel) {
        this.ui.$panels.forEach((val, idx) => {
          if (val === matchedPanel) {
            this.index = idx;
          }
        });
        this.setFocus();
      }
    }
  }

  setFocus() {
    // undo tab control selected state,
    // and make them not selectable with the tab key
    // (all tabs)
    this.ui.$tabs.forEach((tab) => {
      tab.setAttribute('tabindex', '-1');
      tab.setAttribute('aria-selected', 'false');
      tab.classList.remove('selected');
    });

    // hide all tab panels.
    this.ui.$panels.forEach((panel) => {
      panel.classList.remove('selected');
    });

    // make the selected tab the selected one, shift focus to it
    this.ui.$tabs[this.index].setAttribute('tabindex', '0');
    this.ui.$tabs[this.index].setAttribute('aria-selected', 'true');
    this.ui.$tabs[this.index].classList.add('selected');
    this.ui.$tabs[this.index].focus();


    // add a current class also to the tab panel
    // controlled by the clicked tab
    const id = this.ui.$tabs[this.index].getAttribute('data-href');
    this.element.querySelector(`#${id}`).classList.add('selected');
  }
}

registerModule('Tabs', Tabs);
